import React from 'react';

interface ListItemRowProps {
  label: string;
  value: React.ReactNode;
}

export function ListItemRow({ label, value }: ListItemRowProps) {
  return (
    <div className="flex items-center gap-1.5 text-sm">
      <span>{`${label}:`}</span> {value}
    </div>
  );
}
